import { render } from "./Dashboard.vue?vue&type=template&id=7664a80b&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=7664a80b&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=7664a80b&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7664a80b"]])

export default __exports__